import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";

import { DataRowState, Utilities } from "@tylertech/shared-module";
import { SecurityService } from "@tylertech/core-module";
import { EntityAlert } from "@tylertech/tyler-api-types";

import { AlertCardInfo, EntityAlertCode } from "../../interfaces";

@Component({
    selector: "alert-list",
    templateUrl: "./alertList.tmpl.html",
    standalone: false
})
export class AlertListComponent implements OnInit
{
    private readonly $securityService = inject(SecurityService);

    readonly alertListForm: FormGroup;

    @Input() private readonly alertCodes: ReadonlyArray<EntityAlertCode>;
    @Input() private readonly alerts: ReadonlyArray<EntityAlert>;
    @Input() readonly isAdd: boolean;
    @Input() readonly newParentItem: boolean;
    @Input() readonly viewOnly: boolean;

    @Output() private readonly close = new EventEmitter<ReadonlyArray<EntityAlert>>();

    alertCards: Array<AlertCardInfo> = [];
    isLoaded: boolean;

    constructor()
    {
        this.alertListForm = new FormGroup({
            "rows": new FormArray([])
        });
    }

    get hasAlerts(): boolean { return (this.alertCards?.length || 0) > 0; }

    ngOnInit(): void
    {
        // // TODO - This was an `angular.copy` call, was a deep copy required?
        // this.initialAlerts = Utilities.deepCopy(this.alerts);

        this.alerts.forEach(
            a =>
            {
                if (a.ExpirationDateAndTime)
                {
                    a.ExpirationDateAndTime = new Date(a.ExpirationDateAndTime.toString());
                }

                if (a.CreatedDate)
                {
                    a.CreatedDate = new Date(a.CreatedDate.toString());
                }

                if (!a.IsDeleted)
                {
                    this.addAlertCard(a);
                }
            });

        this.isLoaded = true;
    }

    onAddAlertClicked(): void
    {
        const newItem: EntityAlert = {
            ParentId: null,
            Id: Utilities.generateRandomGuid(),
            AlertId: null,
            ExpirationDateAndTime: null,
            Message: "",
            IsSystemAlert: false,
            RowState: DataRowState.Added,
            IsDeleted: false,
            CreatedDate: new Date(),
            CreatedBy: this.$securityService.principle.Fullname,
        };

        // this.alerts.push(newItem);

        this.addAlertCard(newItem);
    }

    addAlertCard(alert: EntityAlert): void
    {
        const alertCard: AlertCardInfo = {
            CardAlert: alert,
            CardAlertCodes: [...this.alertCodes],
        };
        this.alertCards.push(alertCard);
    }

    onClose(): void
    {
        // this.alerts = this.initialAlerts;
        this.close.emit(this.alerts);
    }

    onDelete(alert: EntityAlert): void
    {
        alert.RowState = DataRowState.Deleted;
        alert.IsDeleted = true;

        // this.alerts = this.alerts.filter(filterAlert => filterAlert !== alert);
        this.alertCards = this.alertCards.filter(card => card.CardAlert !== alert);
    }

    save(): void
    {
        if (this.alertListForm.invalid)
        {
            return;
        }

        for (const alert of this.alerts)
        {
            if (alert.RowState === DataRowState.Unchanged)
            {
                alert.RowState = DataRowState.Modified;
            }
        }

        this.close.emit(this.alerts);
    }

    isDelete(alertCard: AlertCardInfo): boolean
    {
        return alertCard.CardAlert.RowState === DataRowState.Deleted;
    }
}
